import { render, staticRenderFns } from "./indexDealer.vue?vue&type=template&id=2f033564&"
import script from "./indexDealer.vue?vue&type=script&lang=js&"
export * from "./indexDealer.vue?vue&type=script&lang=js&"
import style0 from "./indexDealer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports